<template>
    <div class="flex items-center justify-center bg-gray-200 px-4 py-2 rounded-full space-x-2 cursor-pointer mx-1 hover:bg-gray-300 transition-colors duration-300 ease-in-out"
    @click="$emit('edit')"
    >
        <span class="text-gray-700 text-14px">
            {{ filter.label }}
        </span>
        <span class="bg-gray-400 rounded-full p-1 ml-1 hover:bg-red-400 hover:text-gray-100 cursor-pointer h-6 w-6 flex items-center justify-center transition-colors duration-300 ease-in-out"
            style="transform: translateX(7px);"
            @click.stop="$emit('remove')">
            <font-awesome-icon
                :icon="['far', 'times']"
            ></font-awesome-icon>
        </span>

  </div>
</template>

<script>

export default {
    emits: ['edit', 'remove'],
    props: {
        filter: {
            type: Object,
            required: true
        }
    },
}

</script>